export const ICD10_PRIMARY_FIELD = 'icd10_primary_diagnosis'
export const ICD10_SECONDARY_FIELD = 'icd10_secondary_diagnosis'
